<script>
import {ContentStatus, ExternalProposalType} from "@/store/model/ExtraProposalAttributes";
import {VersionedEntityStatus} from "@/store/model/VersionedEntityStatus";
import {setUrlParam} from "@/baseUtils";
import {mapActions, mapState} from "pinia";
import {authStore} from "@/store/authStore";
import {proposalStore} from "@/store/proposalStore";
import {editProposalStore} from "@/store/editProposalStore";
import {bankIdStore} from "@/store/bankIdStore";
import {opinionStore} from "@/store/opinionStore";
import {argumentStore} from "@/store/argumentStore";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import BaseLayout from "@/components/BaseLayout.vue";
import ProposalDraftInfoMessage from "@/views/proposal/ProposalDraftInfoMessage.vue";
import ProposalWarnMessage from "@/views/proposal/ProposalWarnMessage.vue";
import ProposalGeneralInfo from "@/views/proposal/proposal-general-info/ProposalGeneralInfo.vue";
import ProposalOpinionSection from "@/views/proposal/ProposalOpinionSection.vue";
import ProposalArgument from "@/views/proposal/proposal-argument/ProposalArgument.vue";
import ProposalNoArguments from "@/views/proposal/ProposalNoArguments.vue";
import ProposalCounterSection from "@/views/proposal/ProposalCounterSection.vue";
import ProposalArgumentsList from "@/views/proposal/ProposalArgumentsList.vue";
import ProposalOpinionsOfOthers from "@/views/proposal/ProposalOpinionsOfOthers.vue";
import BaseSidebar from "@/components/BaseSidebar.vue";
import ProposalActionBar from "@/views/proposal/proposal-action-bar/ProposalActionBar.vue";
import ProposalNotAvailable from "@/views/proposal/ProposalNotAvailable.vue";
import ProposalLifeCircleModal from "@/views/proposal/proposal-modals/ProposalLifeCircleModal.vue";
import ProposersListModal from "@/components/Modals/ProposersListModal.vue";
import ActualProposalModal from "@/components/Modals/ActualProposalModal.vue";
import EditProposalView from "@/views/proposal/proposal-edit/EditProposalView.vue";
import ProposalAlmostPublishModal from "@/views/proposal/proposal-modals/ProposalAlmostPublishModal.vue";
import ProposalSavedDraftModal from "@/views/proposal/proposal-modals/ProposalSavedDraftModal.vue";
import ProposalNeedUpdateModal from "@/views/proposal/proposal-edit/ProposalNeedUpdateModal.vue";
import ProposalCantSavingModal from "@/views/proposal/proposal-edit/ProposalCantSavingModal.vue";
import ProposalLogbookModal from "@/views/proposal/proposal-modals/ProposalLogbookModal.vue";
import ShareSelectEntityModal from "@/components/Modals/ShareSelectEntityModal.vue";
import {appStore} from "@/store/appStore";
import {StructuredDataType} from "@/store/model/StructuredData";

export default {
  name: "ProposalView",
  components: {
    BaseLayout,
    ProposalDraftInfoMessage,
    ProposalWarnMessage,
    ProposalGeneralInfo,
    ProposalOpinionSection,
    ProposalArgument,
    ProposalNoArguments,
    ProposalCounterSection,
    ProposalArgumentsList,
    ProposalOpinionsOfOthers,
    BaseSidebar,
    ProposalActionBar,
    ProposalNotAvailable,
    ProposalLifeCircleModal,
    ProposersListModal,
    ActualProposalModal,
    EditProposalView,
    ProposalAlmostPublishModal,
    ProposalSavedDraftModal,
    ProposalNeedUpdateModal,
    ProposalCantSavingModal,
    ProposalLogbookModal,
    ShareSelectEntityModal
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState(authStore, [
      'userInfo',
      'userActiveProfile',
      'hasHeaderMessage'
    ]),
    ...mapState(proposalStore, [
      'proposalInfo',
      'editedProposalData',
      'proposalNotAvailable',
      'actualProposalInfo',
      'actualProposalModalState',
      'proposalArguments',
      'proposalNeedUpdateModalState',
      'proposalLogbookModalState'
    ]),
    ...mapState(opinionStore, [
        'currentOpinion'
    ]),
    ...mapState(editProposalStore, [
      'editProposalViewState',
      'proposalCantSavingModalState',
      'savedDraftModalState',
      'almostPublishModalState'
    ]),
    isArgView() {
      return this.$route.name === "ArgumentView";
    },
    isOpinionView() {
      return this.$route.name === "OpinionView";
    },
    proposalId() {
      let proposalId = '';
      if (this.$route.name === 'OpinionView') {
        proposalId = this.currentOpinion ? this.currentOpinion.proposalIds[0] : '';
      } else {
        proposalId = !this.$route.params.id.includes('pp') ? this.$route.params.id : '';
      }

      return proposalId;
    },
    opinionNumber() {
      return this.$route.params.id.includes('oo') ? this.$route.params.id : '';
    },
    proposalIssueNumber() {
      return this.$route.params.id.includes('pp') ? this.$route.params.id : '';
    },
    isDraftProposal() {
      return this.proposalInfo.status === VersionedEntityStatus.DRAFT;
    },
    isLatestProposalVersion() {
      return this.proposalInfo.status === VersionedEntityStatus.CURRENT || this.proposalInfo.status === VersionedEntityStatus.DRAFT;
    },
    argumentsWithContent() {
      return this.proposalArguments.filter((arg)=> !!arg.argumentDetailed)
    },
    proposalArgumentsList() {
      return this.proposalArguments.filter((arg)=> !!arg.argumentDetailed || arg.privateSinceDateTime)
    },
    counterProposal() {
      const externalProposalType = this.proposalInfo.extraAttributes.externalProposalType;
      return externalProposalType === ExternalProposalType.COUNTER_MOTION;
    },
    reviewedProposal() {
       const contentStatus = this.proposalInfo.extraAttributes.contentStatus;
       return contentStatus === null || contentStatus === ContentStatus.PROCESSED;
    },
    opinionDisabledState() {
      // return this.counterProposal;
      return true; //TODO enable in "Support for Opinions" release
    },
    activeUserType() {
      return this.userActiveProfile.type;
    },
    hasActualProposal() {
      return this.proposalInfo && this.proposalInfo.actualProposal;
    }
  },
  methods: {
    ...mapActions(bankIdStore, ['checkBankIdAuthSession']),
    ...mapActions(baseLoaderStore, [
      'showBaseLoader',
      'hideBaseLoader'
    ]),
    ...mapActions(proposalStore, [
      'getProposalInfo',
      'getProposalInfoByIssueNumber',
      'setProposalArguments',
      'toggleEditProposalState',
    ]),
    ...mapActions(opinionStore, [
      'getOpinionInfoAction',
      'getOpinionsAction',
    ]),
    ...mapActions(argumentStore, [
      'getArguments',
      'setActiveArgument'
    ]),
    ...mapActions(editProposalStore, [
      'toggleEditProposalState',
      'closeEditProposalView',
    ]),
    ...mapActions(appStore, [
      'setupStructuredData',
    ]),

    saveProposal(actionType) {
      this.$refs.editProposalView.saveProposal(actionType, true);
    },
    startEditingProposal() {
      this.checkBankIdAuthSession(() => {
        this.showBaseLoader();
        this.toggleEditProposalState();
      });
    },
    startPublishProposal() {
      this.checkBankIdAuthSession(() => {
        this.showBaseLoader();
        this.toggleEditProposalState();

        setUrlParam('publish', true);
      });
    },
    loadProposalDataInfo(paramProposalIssueNumber) {
      if (this.$route.query && this.$route.query.editMode) {
        this.startEditingProposal();
      } else if (this.proposalIssueNumber || paramProposalIssueNumber) {
        const proposalVersion = this.$route.params.version;
        this.getProposalInfoByIssueNumber(this.proposalIssueNumber || paramProposalIssueNumber, proposalVersion).then(() => {
          if (this.proposalInfo) {
            this.afterGetProposalActions();
          }
        });
      } else {
        this.getProposalInfo(this.proposalId).then(() => {
          this.afterGetProposalActions();
        });
      }
    },
    loadOpinionInfoData(paramOpinionNumber) {
      if (this.opinionNumber || paramOpinionNumber) {
        this.getOpinionsAction({
          opinionNumbers: this.opinionNumber || paramOpinionNumber
        }).then((resp)=> {
          const opinionId = resp.data.content[resp.data.content.length - 1].id;
          this.getOpinionInfoAction(opinionId).then(()=> {
            this.loadProposalDataInfo();
          });
        });
      } else {
        this.getOpinionInfoAction(this.$route.params.id).then(()=> {
          this.loadProposalDataInfo();
        });
      }
    },
    afterGetProposalActions() {
      this.getArguments( {
        page: 0,
        proposalIds: this.proposalInfo.id,
        size: 30,
        statuses: this.isDraftProposal ? 'DRAFT' : 'CURRENT'
      }).then((resp) => {
        this.setProposalArguments(resp.data.content);
        if (this.proposalArguments.length > 0) {
          const idx = this.proposalArguments.findIndex(a => !!a.argumentDetailed);
          if (idx >= 0) {
            this.setActiveArgument(this.proposalArguments[idx], idx);
          }
        }
        this.hideBaseLoader();
      })
    }
  },
  beforeMount() {
    if (this.isArgView) {
      this.setupStructuredData(StructuredDataType.ARGUMENT, this.$route.params.id);
    } else if (this.isOpinionView) {
      this.setupStructuredData(StructuredDataType.OPINION, this.$route.params.id);
    } else {
      this.setupStructuredData(StructuredDataType.PROPOSAL, this.$route.params.id);
    }
  },
  beforeUnmount() {
    this.closeEditProposalView();
  },
  mounted() {
    if (this.isArgView) {
      this.getArguments( {
        ids: this.$route.params.id
      }).then((resp) => {
        const arg = resp.data.content[0];
        if (arg.opinionNumber) {
          this.loadOpinionInfoData(arg.opinionNumber);
          this.$router.resolve({ name: 'OpinionView', params: { id: this.opinionNumber }});
        } else {
          this.loadProposalDataInfo(arg.proposalIssueNumber);
          this.$router.push({ name: 'ProposalView', params: { id: arg.proposalIssueNumber }});
        }
      })
    } else {
      if (this.isOpinionView) {
        this.loadOpinionInfoData();
      } else {
        if (this.$route.query && this.$route.query.editMode) {
          this.startEditingProposal();
        } else {
          this.loadProposalDataInfo();
        }
      }
    }
  }
}
</script>

<template>
<base-layout>
  <template v-if="!proposalNotAvailable">
    <div v-if="proposalInfo" class="content-section__wrap proposal-view">
      <template v-if="editProposalViewState">
        <edit-proposal-view ref="editProposalView"
                            :param-proposal-id="proposalInfo.id"
        />
      </template>
      <template v-else>
        <proposal-draft-info-message v-if="isDraftProposal"
                                     @on-edit-proposal="startEditingProposal"
                                     @on-go-to-publish="startPublishProposal"
        />
        <proposal-warn-message v-if="!isLatestProposalVersion"/>
        <proposal-general-info
            ref="proposalGeneralInfo"
            :proposal-info="proposalInfo"
        />
        <proposal-opinion-section v-if="isOpinionView"/>
        <template v-if="!counterProposal">
          <proposal-argument v-if="argumentsWithContent.length > 0"
                             :arg-id="proposalInfo.argId"
                             :proposal-id="proposalInfo.id"
          />
          <proposal-no-arguments v-else/>
        </template>
        <proposal-arguments-list v-if="proposalArgumentsList.length > 0"/>
        <div style="display: flex; justify-content: space-between;">
          <template v-if="counterProposal">
            <proposal-counter-section :reviewed-proposal="reviewedProposal"
                :proposal-info="{
                  proposalTitle: proposalInfo.title,
                  issueNumber:  proposalInfo.issueNumber
                }"
            />
          </template>
          <template v-else>
            <proposal-opinions-of-others/>
          </template>
          <base-sidebar/>
        </div>
      </template>
    </div>
    <proposal-action-bar v-if="proposalInfo"
                         :disabled-state="opinionDisabledState"
                         :active-user-type="activeUserType"
                         @on-save-proposal="saveProposal"
                         @on-edit-proposal="startEditingProposal"
    />

    <!-- Modals-->
    <proposal-life-circle-modal :proposal-id="proposalId"/>
    <proposers-list-modal v-if="proposalInfo"
                          :proposal-title="proposalInfo.title"
                          :proposers-list="proposalInfo.extraAttributes.spokes"
    />
    <actual-proposal-modal v-if="hasActualProposal && actualProposalModalState"
                           :actual-proposal="actualProposalInfo"
    />
    <proposal-almost-publish-modal v-if="almostPublishModalState"/>
    <proposal-saved-draft-modal v-if="savedDraftModalState"/>
    <proposal-need-update-modal v-if="proposalNeedUpdateModalState"/>
    <proposal-cant-saving-modal v-if="proposalCantSavingModalState"/>
    <proposal-logbook-modal v-if="proposalLogbookModalState"/>
    <share-select-entity-modal/>
  </template>
  <proposal-not-available v-else/>
</base-layout>
</template>

<style lang="scss" scoped>
.proposal-view {
  max-width: 970px;
}
</style>

